export default __webpack_public_path__ + "static/media/vines.db8db425.jpg";